import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { ModuleModule } from './module/module.module';
import { ApiService } from './service/api.service';
import { GlobalLoaderComponent } from './service/global-loader/global-loader.component';
import { GlobalLoaderInterceptorService } from './service/global-loader/global-loader-interceptor.service';
import { GlobalLoaderService } from './service/global-loader/global-loader.service';

@NgModule({
  declarations: [
    AppComponent,
    GlobalLoaderComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ModuleModule,
    AppRoutingModule
  ],
  providers: [    
    GlobalLoaderService,
    ApiService,
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: GlobalLoaderInterceptorService, 
      multi: true 
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (setting: ApiService) =>
        function() {
          return setting.getConfig();
        },
      deps: [ApiService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
